import { render, staticRenderFns } from "./DeleteTeamForm.vue?vue&type=template&id=7fee01bc&"
import script from "./DeleteTeamForm.vue?vue&type=script&lang=js&"
export * from "./DeleteTeamForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports